import { environment } from 'src/environments/environment';
export class constants {
  static TITLE = environment.message;
  static BASE_API_ENDPOINT = environment.Settings.WEB_TARGET_API + 'api/';
  static FILE_SIZE_NOTE = 'File size must be greater than {0} bytes.';
  static FILE_TYPE_VALIDAION_MESSAGE = 'Only .xlsx files are allowed.';
  static FILE_SIZE_VALIDAION_MESSAGE = 'File size exceeded than ';
  static FILE_SCAN_MESSAGE =
    'The file uploaded was rejected by the file scanner. Please make sure this is not an infected file.';
  static All_RIGHTS_MESSAGE = 'All rights reserved';
  static FOOTER_TEXT = 'Beon Batch Rater';
  static PageSize = 'PageSize';
  static AddUserheader = 'Add User';
  static EditUserheader = 'Edit User';
  static MGIdentificationNumber = 'MGIdentificationNumber';
  static Parcel_API_UserName = 'Parcel API UserName';
  static Parcel_API_Password = 'Parcel API Password';
  static RatingResponseLevel = 'RatingResponseLevel';
  static ArchwaySpecific = 'ArchwaySpecific';
  static BestRates = 'BestRates';
  static AllRates = 'AllRates';
  static Submission = 'Submission';
  static RateErrorMessage = 'Select atleast one rate level';
  static Run_As = 'Run As';
  static Edit = 'Edit';
  static Delete = 'Delete';
  static Reactivate = 'Troubleshoot';
  static ApplicationSettings = 'ApplicationSettings';
  static TermsPrivacy = 'TermsPrivacy';
  static ContactNumber = 'ContactNumber';
  static EmailID = 'EmailID';
  static FileSize = 'FileSize';
  static copy = 'Copy';
  static ParcelCustomerIdentification = 'ParcelCustomerIdentification';
  static FileInProgress = 'FileInProgress';
  static FileInProgressMessage =
    'Your changes will be discarded, do you want to continue?';
  static CopyRightText = '© 2023 Transportation Insight';
  static SessionExpiredMessage = 'Session Time Out !. Please Login Again';
  static UnauthorizedMessage =
    'You do not have permission to access this application. Please contact Admin.';
  static AddCompany = 'Add Company';
  static EditCompany = 'Edit Company';
  static RunAs = 'RunAs';
  static CancelMessage = 'Are you sure you want to cancel this item?';
  static DeleteMessage = 'Are you sure you want to delete this item?';
  static ParcelCarrier = 'ParcelCarrier';
  static ALL = 'ALL';
  static DefaultTimeInterval = 30000;
  static SelectCompany = 'Select Company';
  static FileProcessSuccessMessage = 'File processed successfully';
  static FileProcessFailedMessage = 'File processing failed';
  static Freight = 'Freight';
  static FreightParcel = 'Freight/Parcel';
  static Parcel = 'Parcel';
  static ReleaseNote = 'ReleaseNotes';
  static ServiceTypes = 'ServiceTypes';
  static ServiceErrorMessage = 'Select atleast one service';
  static CompanyErrorMessage = 'Select atleast one company';
  static MGParcelErrorMessage = 'Please provide MGHierarchy/ParcelHierarchy';
  static CompanyNameErrorMessage = 'Please provide company name';
}
